import type { ViewDetailsResponse } from '@data-access/connect/tc-tcps';
import {
  useApiServices,
  useCapabilityRegistryContext,
  useDataContext,
  usePaneContext,
} from '@mobile-mapping/providers';
import { useConnectProject } from '@trimble/connect-project-providers';
import { useLogger } from '@trimble/solidjs-utils';
import { asError } from '@trimble/logging';
import { loadViewWithReservedData } from './load-view-with-reserved-data';

/**
 * Returns a callback that loads a saved view: layout → pane state → shared
 * data → trajectories → navigation states → per-pane data.
 */
export function useLoadView(): (view: ViewDetailsResponse) => void {
  const logger = useLogger().getLogger('loadMultipaneView');
  const { tcTcpsApi } = useApiServices();
  const { capabilityRegistry } = useCapabilityRegistryContext();
  const { dataState, dataLoadingService } = useDataContext();
  const { layouts, setLayouts } = usePaneContext();
  const { selectedRegion } = useConnectProject();

  return (view: ViewDetailsResponse) => {
    const region = selectedRegion();
    if (!region) return;

    void loadViewWithReservedData(view, {
      tcTcpsApi,
      capabilityRegistry,
      dataLoadingService,
      dataState,
      layouts,
      setLayouts,
      region,
      logger,
    }).catch((error: unknown) =>
      logger.error(`Failed to load view ${view.id}`, undefined, asError(error))
    );
  };
}
